'use client';

import { ArrowRight } from 'lucide-react';
import Link from 'next/link';

export default function CategoryCard({ title, description, icon: Icon, href }) {
  return (
    <Link href={href} className="group rounded-xl sm:rounded-2xl overflow-hidden cursor-pointer transform hover:scale-102 transition-all duration-300 bg-white border-2 border-gray-200 hover:border-[#23994F] shadow-lg hover:shadow-xl block h-full min-h-[220px] sm:min-h-[260px]">

      <div className="p-6 sm:p-8 h-full flex flex-col justify-between">

        <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#23994F]/10 rounded-xl sm:rounded-2xl flex items-center justify-center mb-4 sm:mb-6 group-hover:bg-[#23994F]/20 transition-all duration-300">
          <Icon size={28} className="sm:w-8 sm:h-8 text-[#23994F] group-hover:scale-105 transition-transform" />
        </div>


        <div className="flex-1">
          <h3 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-[#23994F] transition-colors">
            {title}
          </h3>
          <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 line-clamp-2">{description}</p>
        </div>


        <div className="flex items-center gap-2 text-[#23994F] font-semibold group-hover:gap-3 transition-all text-sm sm:text-base">
          <span>Découvrir</span>
          <ArrowRight size={18} className="sm:w-5 sm:h-5 group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
}
